export const sumoPracticeProducts = [
  { id: "152592f3-9507-430b-a717-7483840a59d9", name: "Ryogoku" },
  { id: "4d45bef3-3120-408d-85f4-7d6ca585b9af", name: "Oshiage" },
  { id: "54ea71a7-f928-496f-9a43-e50d17a2f585", name: "Kiyosumi-Shirakawa" },
] as const;

export const sumoPracticeProductsIds = sumoPracticeProducts.map(({ id }) => id);

export function isSumoPracticeProductId(
  id: string
): id is (typeof sumoPracticeProductsIds)[number] {
  return (sumoPracticeProductsIds as readonly string[]).includes(id);
}
